module.exports = __webpack_public_path__ + "img/login-copaamistadiess.41c4a164.svg";